import { IconButton, Tooltip } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
import EditIcon from "@mui/icons-material/Edit";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import Styles from "./RASelectionModal.module.css";
import { ErrorMessage } from "../../../commons/Toast/ErrorMessage";

const BidRow = ({
  bid,
  index,
  isFirstBidWithdrawn,
  isFirstBidSelected,
  isCloseDatePassed,
  showSellerMinQty,
  activeReq,
  selectedBids,
  rejectedBids,
  sessionAbscondBidIds,
  editingAlloc,
  setEditingAlloc,
  setUpdateQtyConfirmation,
  openEditAlloc,
  closeEditAlloc,
  onSelect,
  onReject,
}) => {
  const isEditing = editingAlloc?.bidId === bid?.id;
  const isAccepted = selectedBids.includes(bid?.id);
  const isRejected = rejectedBids.includes(bid?.id);
  const isWithdrawn = bid?.winnerBidStatus === "WITHDRAWN";
  const isNullQuantity = bid?.selectedQuantity == null;
  const isLockedByFirstBid = index > 0 && !isFirstBidSelected;

  // req 1 + req 6: ABSCOND purely from quantity vs seller minimum, no seller approval
  const isAbscond =
    showSellerMinQty &&
    bid?.minBidQuantityMw &&
    bid?.selectedQuantity != null &&
    bid?.selectedQuantity < Number(bid?.minBidQuantityMw);

  // only show abscond status in the STATUS column after the user has acted in this session
  const showAsAbscond = isAbscond && sessionAbscondBidIds?.has(bid?.id);

  return (
    <div
      className="display_flex_row tableDetails"
      style={isNullQuantity || isLockedByFirstBid ? { opacity: 0.5, pointerEvents: "none", cursor: "not-allowed" } : {}}
    >
      <div style={{ width: "15%" }}>{bid?.bidPrice}</div>
      <div style={{ width: "15%" }}>{bid?.bidQuantityMw}</div>
      {showSellerMinQty && (
        <div style={{ width: "15%" }}>{bid?.minBidQuantityMw || "-"}</div>
      )}

      {/* Allocated Qty */}
      <div style={{ width: "25%" }}>
        {bid?.selectedQuantity || bid?.requestedQuantity || "-"}
        {/* {isEditing ? (
          <div
            className={Styles.allocatedInputMainCont}
            onClick={(e) => e.stopPropagation()}
          >
            <input
              type="number"
              value={editingAlloc.qty}
              onChange={(e) => {
                const val = e.target.value;
                if (val !== "" && !/^\d*\.?\d{0,3}$/.test(val)) return;
                const minBidQty = bid?.bidQuantityMw;

                // req 2: first bid cannot go below seller minimum
                if (
                  index === 0 &&
                  showSellerMinQty &&
                  bid?.minBidQuantityMw &&
                  val !== "" &&
                  Number(val) < Number(bid?.minBidQuantityMw)
                )
                  return ErrorMessage(
                    `First bid allocated quantity cannot be below seller minimum of ${bid?.minBidQuantityMw} MW.`,
                  );

                if (showSellerMinQty && val !== "" && Number(val) >= minBidQty)
                  return ErrorMessage(
                    "Allocated quantity should be less than bid quantity.",
                  );

                setEditingAlloc((prev) => ({ ...prev, qty: val }));
              }}
            />
            <div className={Styles.bidSelMain}>
              <div onClick={closeEditAlloc}>
                <ClearIcon style={{ fontSize: "10px" }} />
              </div>
              <div
                onClick={() =>
                  setUpdateQtyConfirmation({
                    status: true,
                    bidId: bid?.id,
                    minQty: activeReq?.minimumQty,
                    minBidQuantityMw: bid?.minBidQuantityMw,
                    editingQty: editingAlloc?.qty,
                    index,
                  })
                }
              >
                <DoneIcon style={{ fontSize: "10px" }} />
              </div>
            </div>
          </div>
        ) : (
          <div className={Styles.allocationMain}>
            <span>
              {bid?.selectedQuantity || bid?.requestedQuantity || "-"}
            </span>
            {showAsAbscond ? (
              <Tooltip title="Rejected due to quantity below minimum bid quantity.">
                <IconButton>
                  <PriorityHighIcon
                    style={{ cursor: "pointer", height: "16px", width: "16px", color: "red" }}
                  />
                </IconButton>
              </Tooltip>
            ) : isRejected || isWithdrawn ? (
              <></>
            ) : (
              <EditIcon
                onClick={() => !isCloseDatePassed && openEditAlloc(bid)}
                style={{
                  fontSize: "16px",
                  color: isCloseDatePassed ? "#cccccc" : "#34656D",
                  cursor: isCloseDatePassed ? "not-allowed" : "pointer",
                  pointerEvents: isCloseDatePassed ? "none" : "auto",
                }}
              />
            )}
          </div>
        )} */}
      </div>

      {/* Bank Guarantee */}
      <div style={{ width: "15%" }} className={Styles.bankGuaranteeContainer}>
        <span>
          {bid?.bankGuaranteeAmount
            ? "₹" + bid.bankGuaranteeAmount.toLocaleString("en-IN")
            : "EMD"}
        </span>
        {/* <span
          className={Styles.viewDocs}
          onClick={() =>
            bid.documentId &&
            handlePreviewGeneralTerms(bid.documentId, {
              title: "Bank Guarantee Document Preview",
            })
          }
        >
          {bid.documentId ? "View Doc" : "-"}
        </span> */}
      </div>

      {/* Status — req 6: no Pending state */}
      <div style={{ width: "20%" }} className={Styles.bidSectionMainContainer}>
        {isFirstBidWithdrawn || isWithdrawn ? (
          <div className="rejected">Withdrawn</div>
        ) : showAsAbscond || isNullQuantity ? (
          <div className="rejected">Rejected</div>
        ) : (
          <>
            <div
              className={Styles.bidSelMain}
              style={
                isCloseDatePassed
                  ? {
                      opacity: 0.4,
                      pointerEvents: "none",
                      cursor: "not-allowed",
                    }
                  : {}
              }
            >
              <div
                className={isRejected ? Styles.rejectedBid : ""}
                onClick={() => !isCloseDatePassed && onReject(bid?.id, index)}
              >
                <ClearIcon style={{ fontSize: "10px" }} />
              </div>
              <div
                className={isAccepted ? Styles.selectedBids : ""}
                onClick={() => !isCloseDatePassed && onSelect(bid?.id, index)}
              >
                <DoneIcon style={{ fontSize: "10px" }} />
              </div>
            </div>
            <div
              className={`${Styles.bidSelStatus} ${
                isAccepted ? "accepted" : isRejected ? "rejected" : ""
              }`}
            >
              {isAccepted ? "Accepted" : isRejected ? "Rejected" : "-"}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default BidRow;
